import styled from 'styled-components';

export const BannerCard = styled.div`
    margin-top: 24px;
    margin-bottom: 20px;
`;

export const BannerWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
`;

export const BannerContentWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 24px;
`;

export const BannerActionWrapper = styled.button`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 4px;
    background: none;
    border: none;
`;
